import * as d3 from "d3";
import _ from "lodash";
import moment from "moment";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Button, Divider } from "semantic-ui-react";
import { XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LineChart, Line, Brush, BarChart, Bar } from 'recharts';

const allColors = ['#1f77b4', '#2ca02c', '#d62728', '#ff7f0e', '#9467bd'].concat(_.range(10).map(i => d3.schemeCategory10[i + 6]))
export function MyBarChart(props: { xValues: string[], yData: number[][], labels: string[] }) {
    const [selectedLabels, setSelectedLabels] = useState<string[]>(props.labels);
    const elementRef = useRef<HTMLDivElement>(null);
    const [labelColors, setLabelColors] = useState<string[]>(props.labels.map((l, i) => allColors[i]));
    const [barData, setBarData] = useState<any[]>(props.yData.map((ds, i) => {
        const d: any = { date: props.xValues[i] };
        props.labels.forEach((l, li) => {
            d[l] = ds[li]
        });

        return d;
    }));
    const [slideIndex, setSlideIndex] = useState(Math.max(props.yData.length - 7, 0));

    const [width, setWidth] = useState(0);

    useEffect(() => {
        setLabelColors(props.labels.map((l, i) => allColors[i]));
    }, [props.labels]);

    useEffect(() => {
        setSlideIndex(Math.max(props.yData.length - 7, 0));
    }, [props.yData.length]);

    useEffect(() => {
        const selectedIndexes = selectedLabels.map(l => props.labels.indexOf(l)).filter(i => i !== -1);

        const start = slideIndex;
        const end = Math.min(props.yData.length, slideIndex + 7);
        const xValues = props.xValues.slice(start, end);
        const yData = props.yData.slice(start, end);

        setBarData(yData.map((ys, yi) => {
            const d: any = { 'date': xValues[yi] };
            selectedLabels.forEach((l, i) => {
                d[l] = ys[selectedIndexes[i]]
            })
            return d;
        }));
    }, [props.xValues, props.yData, props.labels, selectedLabels, slideIndex])

    const slide = function (moveIndex: number) {
        let newIndex = slideIndex + moveIndex;
        if (newIndex < 0) {
            newIndex = 0;
        }
        if (newIndex > props.yData.length - 7) {
            newIndex = props.yData.length - 7;
        }

        setSlideIndex(newIndex);
    }

    useLayoutEffect(() => {
        const width = elementRef.current!.offsetWidth * 0.9;
        setWidth(width);
    }, [])

    return <div>
        <div ref={elementRef}></div>
        <BarChart
            width={width}
            height={300}
            data={barData}
            margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5,
            }}
        >
            <CartesianGrid strokeDasharray="3 1" />
            <XAxis dataKey="date" />
            <YAxis />
            <Tooltip formatter={(d: any) => parseInt(d)} />
            {selectedLabels.map((l, i) => <Bar type="monotone" key={l} dataKey={l} fill={labelColors[props.labels.indexOf(l)]} />)}
        </BarChart>
        <Button.Group size="mini" basic compact style={{ marginLeft: '5rem' }}>
            {props.labels.map((l, i) => <a key={l} className="ui button" ref={(el) => {
                if (el) {
                    el.style.setProperty('color', labelColors[i], 'important');
                    el.style.setProperty('background-color', '#fff', 'important');
                }
            }} style={{ fontWeight: selectedLabels.includes(l) ? 700 : 100, opacity: selectedLabels.includes(l) ? 1 : 0.5 }} onClick={e => {
                e.preventDefault();
                setSelectedLabels(sl => {
                    if (sl.includes(l)) {
                        return sl.filter(l2 => l2 !== l);
                    } else {
                        const newLabels = [...sl, l];
                        return props.labels.filter(l => newLabels.includes(l));
                    }
                });
            }}>{l}</a>)}
        </Button.Group>
        &nbsp;&nbsp;
        <Button size="mini" compact secondary icon="left arrow" onClick={() => slide(-7)} as="a"></Button>
        <Button size="mini" compact secondary icon="right arrow" onClick={() => slide(7)} as="a"></Button>
    </div>
}